/**
 * Rensar kvarvarande scroll-lås / pointer-events från Radix Dialog, Sheet, m.m.
 * Anropas vid route-byte och när mobilmeny stängs så sidan inte "fastnar".
 */
function removeOrphanedRadixLayers() {
  document
    .querySelectorAll('[data-radix-dialog-overlay], [data-radix-focus-guard]')
    .forEach((el) => el.remove());

  /* Fallback om data-attribut saknas (t.ex. halv-renderad shadcn-overlay) */
  document.querySelectorAll('body > div[data-state="open"]').forEach((el) => {
    const cls = typeof el.className === 'string' ? el.className : '';
    if (cls.includes('fixed') && cls.includes('inset-0') && cls.includes('bg-black')) {
      el.remove();
    }
  });

  const root = document.getElementById('root');
  if (root) root.removeAttribute('aria-hidden');
  document.body.removeAttribute('inert');
  document.documentElement.removeAttribute('inert');
}

export function releaseUiScrollLock() {
  if (typeof document === 'undefined') return;
  const { body, documentElement: docEl } = document;
  body.style.removeProperty('pointer-events');
  body.style.removeProperty('overflow');
  body.style.removeProperty('padding-right');
  docEl.style.removeProperty('overflow');
  body.removeAttribute('data-scroll-locked');
  docEl.removeAttribute('data-scroll-locked');
  removeOrphanedRadixLayers();
}

export function scheduleReleaseUiScrollLock() {
  const run = () => releaseUiScrollLock();
  run();
  window.requestAnimationFrame(run);
  window.setTimeout(run, 50);
  window.setTimeout(run, 320);
}
